import React from 'react';
import { useTheme } from '@components/theme';
import classnames from 'classnames';
import { SrcSetPicture } from '@components/shared/Picture';
import DeferredImage from '@components/shared/images/atoms/Image/DeferredImage';
import AspectRatioBox from '@components/shared/AspectRatioBox/AspectRatioBox';
import { SrcSet } from '@lib/image';
import breakpoints from '@constants/breakpoints';
import styles from './DesignerPicksCTA.module.scss';

interface IDesignerPicksCTAProps {
  className?: string;
}

const DesignerPicksCTA = ({ className }: IDesignerPicksCTAProps) => {
  const theme = useTheme();

  return (
    <div
      className={
        classnames(
          styles.CTACard,
          className
        )
      }
    >
      <div className={styles.BackgroundColumn}>
        <div className={styles.ImageWrapper}>
          <AspectRatioBox className={styles.ImageWrapper} aspectRatio={0.67}>
            <SrcSetPicture
              srcSets={getSrcSetForViewport('https://s3.amazonaws.com/static.havenly.com/content/backgrounds/designer-picks-bg.jpg')}
              defaultWidth={1920}
              render={({ imgProps }) => (
                <DeferredImage
                  className={styles.Image}
                  imgProps={{
                    ...imgProps,
                    alt: 'Designer Picks CTA Background'
                  }}
                />
              )}
            />
          </AspectRatioBox>
        </div>
      </div>
      <div className={styles.ContentColumn}>
        <p className={classnames(theme.styles.Body, theme.styles.Contrast)}>Get inspired</p>
        <p className={classnames(theme.styles.Title1, theme.styles.Contrast, styles.Title)}>
          Discover designer picks
        </p>
        <a className={classnames(theme.styles.Button, theme.styles.Primary, styles.Conflicting)} href={'/shop'}>
          Shop now
        </a>
      </div>
    </div>
  );
};

function getSrcSetForViewport(url: string) {
  const mobileSrcSets: Record<string, SrcSet> = {};
  ['webp', 'jpeg'].forEach((format) => {
    mobileSrcSets[format] =
      new SrcSet({
        sizes: new Map([
          [SrcSet.DEFAULT, [1920, 1920]],
          [`${breakpoints['large-phone']}`, [640, 640]],
          [`${breakpoints['large-tablet']}`, [960, 960]],
        ]),
        url,
        props: {
          fit: 'fit-in',
          quality: 99,
          format,
        }
      });
  });

  return mobileSrcSets;
}

export default DesignerPicksCTA;
